import React from "react";

export type FallbackProps = {
  error: Error;
  resetErrorBoundary: (...args: Array<unknown>) => void;
};

export type ErrorBoundaryType = {
  FallbackComponent: React.ComponentType<FallbackProps>;
  onError: (error: Error, info: unknown) => void;
  onReset: () => void;
  children?: React.JSX.Element;
};
type ErrorBoundaryState = {
  errorInfo: any;
  error?: Error | null;
};
export class ErrorBoundary extends React.Component<
  ErrorBoundaryType,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryType) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });

    this.props.onError(error, errorInfo);
  }

  render() {
    if (this.state.error && this.state.errorInfo) {
      const FallbackComponent = this.props.FallbackComponent;

      return (
        <FallbackComponent
          error={this.state.error}
          resetErrorBoundary={this.props.onReset}
        />
      );
    }

    return this.props.children;
  }
}
